import { useCallback, useContext, useEffect, useState } from 'react';
import uuid from 'uuid';
import { hideSuccessNotification as hideSuccessNotificationAction } from '../actions/ui';
import UIContext from '../store/UIState';

/**
 * Hook for notification
 *
 * @returns {{ toasts: { id: string, timeout: number }, onCloseToast: (id: string) => undefined }}
 */
const useNotification = () => {
  const [toasts, setToasts] = useState([]);
  const {
    state: {
      isSuccessNotificationShown,
      isFailureNotificationShown,
      isGetQuestionsInProgress,
      isSubmitInProgress,
      isSurveyEnabled,
      isSurveySubmitted,
    },
    dispatch,
  } = useContext(UIContext);

  // Action Handlers
  const hideNotification = useCallback(() => {
    const action = hideSuccessNotificationAction();
    dispatch(action);
  }, []);

  // Open and Close toasts
  const onOpenToast = useCallback(
    (config) => {
      const { type, message } = config;
      const uid = uuid.v4();
      setToasts(toasts.concat({ id: `${uid}`, timeout: 3000, type, message }));
    },
    [toasts, setToasts]
  );

  const onCloseToast = useCallback(
    (id) => {
      setToasts(toasts.filter((t) => t.id !== id));
      hideNotification();
    },
    [toasts]
  );

  // Effects
  useEffect(() => {
    if (isSuccessNotificationShown) {
      onOpenToast({
        type: 'success',
        message: 'feedback.notifications.submit_success',
      });
    }
    if (isFailureNotificationShown) {
      onOpenToast({
        type: 'error',
        message: 'dev_app.error',
      });
    }
  }, [isSuccessNotificationShown, isFailureNotificationShown]);

  return {
    toasts,
    onCloseToast,
    isGetQuestionsInProgress,
    isSubmitInProgress,
    isSurveyEnabled,
    isSurveySubmitted,
  };
};

export default useNotification;
